import React, { Fragment, useEffect } from 'react'
import { withRouter, Redirect } from 'react-router-dom'
import NProgress from 'nprogress'
import { Spin } from 'antd'
import { Helmet } from 'react-helmet'
import { allowedMenuForAdmin } from 'App'
import Loader from 'components/LayoutComponents/Loader'
import useApp from 'useApp'
import PublicLayout from './Public'
import LoginLayout from './Login'
import MainLayout from './Main'
import { isUserAuthenticated } from '../utils'

const Layouts = {
  public: PublicLayout,
  login: LoginLayout,
  main: MainLayout,
}

let previousPath = ''

const IndexLayout = ({ location: { pathname, search }, user = {}, children }) => {
  const { appLoading, me } = useApp()

  useEffect(() => {
    NProgress.start()
    window.scrollTo(0, 0)
    setTimeout(() => {
      NProgress.done()
    }, 300)
  }, [pathname])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  // NProgress Management
  const currentPath = pathname + search
  if (currentPath !== previousPath) {
    NProgress.start()
  }

  setTimeout(() => {
    NProgress.done()
    previousPath = currentPath
  }, 300)

  // Layout Rendering
  const getLayout = () => {
    if (pathname === '/') {
      return 'public'
    }
    if (/^\/user(?=\/|$)/i.test(pathname)) {
      return 'login'
    }
    return 'main'
  }

  const Container = Layouts[getLayout()]
  const isUserLoading = user.loading
  const isLoginLayout = getLayout() === 'login'

  const BootstrappedLayout = () => {
    // show loader when user in check authorization process, not authorized yet and not on login pages
    if (isUserLoading && !isUserAuthenticated() && !isLoginLayout) {
      return <Loader />
    }
    // redirect to login page if current is not login page and user not authorized
    if (!isLoginLayout && !isUserAuthenticated()) {
      return <Redirect to="/user/login" />
    }
    // redirect to main dashboard when user on login page and authorized
    if (isLoginLayout && isUserAuthenticated()) {
      return <Redirect to="/dashboard" />
    }

    // TODO remove
    if (
      me.email === 'volkan@gekron.com' &&
      !allowedMenuForAdmin.some(menu => pathname.includes(menu))
    ) {
      return <Redirect to="/orders" />
    }
    // in other case render previously set layout
    return <Container>{children}</Container>
  }

  return (
    <Fragment>
      <Helmet titleTemplate="Forwardme.com | %s" title="Forwardme.com" />
      <Spin spinning={appLoading} delay={0}>
        {BootstrappedLayout()}
      </Spin>
    </Fragment>
  )
}

export default withRouter(IndexLayout)
